import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ISuperTableCalculation, ISuperTableCalculationFunction } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { cloneDeep } from 'lodash-es';
import { EMPTY_ARRAY_LENGTH } from '../../../../../../../aumico-lib-core-fe/src/lib';
import { ISuperTableAddCalculationResult } from '../../../../interfaces/super-table-add-calculation-result.interface';
import { ISuperTableItemSelection } from '../../../../interfaces/super-table-item-selection.interface';

@UntilDestroy()
@Component({
    selector: 'super-table-summation-row',
    templateUrl: './super-table-summation-row.component.html',
    styleUrls: ['./super-table-summation-row.component.scss'],
})
export class SuperTableSummationRowComponent implements OnInit, OnChanges {
    @Input() selectionOptions: ISuperTableItemSelection[] = [];
    @Input() existingCalculation: ISuperTableCalculation | undefined;
    selectedItems: ISuperTableItemSelection[] = [];
    titleControl = new FormControl('');
    dropdownOpen = false;

    @Output() calculationOutput: EventEmitter<ISuperTableAddCalculationResult> =
        new EventEmitter<ISuperTableAddCalculationResult>();

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['existingCalculation']?.currentValue) {
            this.dropdownOpen = false;

            this.titleControl.setValue(this.existingCalculation.title);

            const selectedRows = this.existingCalculation.rowsIds;
            const matchingRowSelections = this.selectionOptions.filter((option) => selectedRows.includes(option.name));

            this.selectedItems = cloneDeep<ISuperTableItemSelection[]>(matchingRowSelections);

            this.calculationOutput.emit({
                title: this.titleControl.value,
                function: ISuperTableCalculationFunction.SUMMATION,
                rowSelections: this.selectedItems,
            });
        }
    }

    ngOnInit(): void {
        this.titleControl.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
            if (this.selectedItems.length !== EMPTY_ARRAY_LENGTH) {
                this.calculationOutput.emit({
                    title: value,
                    function: ISuperTableCalculationFunction.SUMMATION,
                    rowSelections: this.selectedItems,
                });
            }
        });
    }

    toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
    }

    onSelectItem(item: ISuperTableItemSelection): void {
        const index = this.selectedItems.findIndex((selected) => selected.name === item.name);
        if (index === -1) {
            this.selectedItems.push(item);
        } else {
            this.selectedItems.splice(index, 1);
        }
        if (this.selectedItems.length === EMPTY_ARRAY_LENGTH) {
            return;
        }

        this.calculationOutput.emit({
            title: this.titleControl.value,
            function: ISuperTableCalculationFunction.SUMMATION,
            rowSelections: this.selectedItems,
        });
    }

    removeItem(item: ISuperTableItemSelection) {
        this.selectedItems = this.selectedItems.filter((selected) => selected !== item);

        if (this.selectedItems.length === EMPTY_ARRAY_LENGTH) {
            return;
        }

        this.calculationOutput.emit({
            title: this.titleControl.value,
            function: ISuperTableCalculationFunction.SUMMATION,
            rowSelections: this.selectedItems,
        });
    }

    isSelected(item: ISuperTableItemSelection): boolean {
        return this.selectedItems.some((selected) => selected.name === item.name);
    }
}
